/** Detailed specialization list for UI dropdowns. */
export const SPECIALIZATION_DETAILS = [
  { name: "Internal Medicine", description: "Primary care, diagnosis" },
  {
    name: "General Physician",
    description: "Primary care doctor for general health concerns",
  },
  { name: "Cardiology", description: "Heart & blood vessels" },
  { name: "Orthopaedics", description: "Bones, joints, muscles" },
  { name: "OB-GYN", description: "Women's health" },
  { name: "Paediatrics", description: "Child & infant care" },
  { name: "Pulmonology", description: "Lung & breathing care" },
  { name: "Endocrinology", description: "Hormones & diabetes" },
  { name: "Nephrology", description: "Kidney care" },
  { name: "Neurology", description: "Brain & nervous system" },
  { name: "Dermatology", description: "Skin, hair, nails" },
  { name: "ENT", description: "Ear, nose, throat" },
  // Live on cuoremd.com before CuoreCare (main branch). Doctors may already hold these, so they
  // must stay selectable or Edit Profile would show their specialization as blank.
  { name: "Urology", description: "Urinary tract health" },
  { name: "Gastroenterology", description: "Digestive system" },
  { name: "Rheumatology", description: "Autoimmune diseases" },
  { name: "General Surgery", description: "Operative care" },
  // Added for the dental case sheet: the platform had no dental option at all, so a dentist had
  // no specialization to choose and therefore no way to be shown dental fields. The name must
  // match the key in the backend's core/clinical/specialtyCasesheets.js exactly.
  { name: "Dentistry", description: "Teeth, gums & oral health" },
  // AYUSH streams. A registered Ayurvedic or Homeopathic practitioner previously had no
  // specialization to pick, which left their profile blank and their registering council
  // unmatched. No specialty case-sheet block is declared for either, so they fall back to the
  // general case sheet — which is the intended behaviour, not an omission.
  { name: "Ayurveda", description: "Ayurvedic medicine" },
  { name: "Homeopathy", description: "Homeopathic medicine" },
];

/** Backward-compatible plain list used by older screens. */
export const SPECIALIZATION_OPTIONS = SPECIALIZATION_DETAILS.map((s) => s.name);
